import { useState } from "react";
import { useTablesContext } from "../../../../context/tablesContextProvider";
import { TableNames } from "../../../../enums/tableNames";

export const useSearchTerm = () => {
  const { getTableDataFromContext } = useTablesContext();
  const tableAttributes = getTableDataFromContext(
    TableNames.MY_PA_ORDERS_FROM_ALGOLIA,
  );

  const [searchTerm, setSearchTerm] = useState(
    tableAttributes?.searchedText ?? "",
  );

  return {
    searchTerm,
    setSearchTerm,
  };
};
